import { useMemo } from 'react';
import { useParams } from 'react-router';

/**
 * Provides the path with the basename param prefixed. Guarantees a trailing slash.
 * @returns {string} a path with a trailing slash.
 * @todo Derive basename from menu url (root loader). This may only be needed for
 * presenting full urls; fetchers for actions and loaders may eventually use the
 * Remix routing convention.
 */
export function useBloomBasename(): string {
  const { basename } = useParams();
  const bloomBasename = useMemo(
    () => (basename ? `/${basename}/` : '/'),
    [basename]
  );

  return bloomBasename;
}
